// extracted by mini-css-extract-plugin
export var cardHeader = "_so-0";
export var reorderHandle = "_so-3";
export var titleArea = "_so-1";
export var titleAreaWithHandle = "_so-2";